import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, CURRENCY, PRICE_VALUE } from '../data/config';
import { trackEvent } from '../utils/metaPixel';
type CTAButtonProps = {
  label?: string;
  note?: string;
  className?: string;
};
export function CTAButton({
  label = 'IR AL PAGO SEGURO',
  note,
  className = ''
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center gap-3 ${className}`} data-id="element-105" data-mp="2g1oamro9zmgd">
      <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('InitiateCheckout', {
      value: PRICE_VALUE,
      currency: CURRENCY
    })} className="group inline-flex w-full max-w-xl items-center justify-center gap-3 rounded-full bg-accent px-8 py-5 text-center text-sm font-bold uppercase tracking-wide text-white shadow-[0_10px_40px_-12px_rgba(10,132,255,0.9)] transition-[transform,background-color] duration-200 ease-out hover:-translate-y-0.5 hover:bg-accent-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-soft focus-visible:ring-offset-2 focus-visible:ring-offset-ink-950 sm:text-base" data-id="element-106" data-mp="2ty1olqtlp5q3">
        {label}
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-107" data-mp="1db06mrxze544" />
      </a>
      {note ? <p className="text-center text-xs text-white/45 sm:text-sm" data-id="element-108" data-mp="1n9h2a27v77wi">{note}</p> : null}
    </div>;
}